import React from "react";
import PropTypes from "prop-types";
import { FormItem } from "..";
import { InputGroup } from "react-bootstrap";

const validations = ["postalcode"];
class PostalcodeText extends FormItem {
  static propTypes = FormItem.extendPropTypes({
    onComplete: PropTypes.func,
    completeTrigger: PropTypes.oneOf(["auto", "button"])
  });
  constructor(props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.refList = [React.createRef(), React.createRef()];
    self.lengthList = [3, 4]; // eslint-disable-line no-magic-numbers
    self.onChange = self.onChange.bind(self);
    self.onComplete = self.onComplete.bind(self);
  }
  getCompleteTrigger() {
    const self = this;
    return self.props.completeTrigger || "button";
  }
  getValues() {
    const self = this;
    return (self.getVal() || "-").split("-");
  }
  onChange(index, value) {
    const self = this;
    const values = self.getValues();
    values[index] = value
      .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
      .replace(/[^\d]/g, "");
    const postalCode = values.join("-");
    // .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
    //   return String.fromCharCode(s.charCodeAt(0) - 65248);
    // });
    self.setVal(postalCode);
    if (self.refList[index + 1] && value.length >= self.lengthList[index]) {
      self.refList[index + 1].current.focus();
    }
    if (self.getCompleteTrigger() === "auto") {
      self.onComplete();
    }
  }
  onComplete() {
    const self = this;
    const values = self.getValues();
    const postalcode = values.join("-");
    self.setVal(postalcode);
    if (/^\d{3}-\d{4}$/.test(postalcode) && self.props.onComplete) {
      self.props.onComplete(postalcode.replace("-", ""));
    }
  }
  renderReadonly() {
    const self = this;
    return <p className="mb-0">{self.getVal() || ""}</p>;
  }
  renderInput() {
    const self = this;
    const formControlClassName = `${self.getFormControlClassName() ||
      ""} p-postal-code`;
    const values = self.getValues();
    return (
      <div>
        <div className="form-inline">
          <span className="p-country-name d-none">Japan</span>
          <InputGroup className="w-auto">
            <input
              ref={self.refList[0]}
              type="tel"
              className={formControlClassName}
              value={values[0] || ""}
              maxLength={self.lengthList[0]}
              size={4}
              placeholder="〒"
              onChange={event => self.onChange(0, event.target.value)}
            />
          </InputGroup>
          <span className="mx-1">―</span>
          <InputGroup className="w-auto">
            <input
              ref={self.refList[1]}
              type="tel"
              className={formControlClassName}
              value={values[1] || ""}
              maxLength={self.lengthList[1]}
              size={4}
              onChange={event => self.onChange(1, event.target.value)}
            />
          </InputGroup>
          {self.getCompleteTrigger() === "button" && (
            <button
              onClick={self.onComplete}
              className="btn btn-light btn-sm mt-1 mt-sm-0 ml-sm-3 px-5"
            >
              住所検索
            </button>
          )}
        </div>
        {self.renderValError()}
      </div>
    );
  }
}
export default PostalcodeText;
